export default {
  HeaderTitle: 'Asset Liability Management',
  Title      : 'ALM',
  Tab        : {
    Summary: {
      Title: 'ALM Summary',
      Slug : 'summary'
    },
    LoansPortfolio: {
      Title: 'Loans Portfolio',
      Slug : 'loans-portfolio'
    },
    DepositsPortfolio: {
      Title: 'Deposits Portfolio',
      Slug : 'deposits-portfolio'
    },
    InvestmentsPortfolio: {
      Title: 'Investments Portfolio',
      Slug : 'investments-portfolio'
    }
  },

  Section: {
    ALMix: {
      Title    : 'AL Mix',
      Tooltip  : 'MISSING TOOLTIP',
      TitleInfo: 'Asset Liability Mix Overview',

      Assets: {

        Title      : 'Assets',
        Subtitle   : 'Breakdown of assets',
        Loans      : 'Loans',
        Investments: 'Investments'
      },
      Liabilities: {
        Title   : 'Liabilities',
        Subtitle: 'Breakdown of liabilities',
        Deposits: 'Deposits',
        Equity  : 'Equity'
      }
    },
    Liquidity: {
      Title                   : 'Liquidity',
      Tooltip                 : 'MISSING TOOLTIP',
      TitleInfo               : 'Liquidity Metrics Overview',
      LiquidityCoverage       : 'Liquidity Coverage',
      LoansVsDeposits         : 'Loans vs Deposits',
      LiquidVsTotalAssets     : 'Liquid vs Total Assets',
      CoreVsTotalDeposits     : 'Core vs Total Deposits',
      UninsuredVsTotalDeposits: 'Uninsured vs Total Deposits',
      Loans                   : 'Loans',
      Deposits                : 'Deposits',
      CoreDeposits            : 'Core Deposits',
      UninsuredDeposits       : 'Uninsured Deposits',
      TotalDeposits           : 'Total Deposits',
      LiquidAssets            : 'Liquid Assets',
      TotalAssets             : 'Total Assets'
    },
    Profitability: {
      Title       : 'Profitability',
      TitleInfo   : 'Profitability Overview',
      BankActivity: 'Bank Activity',
      ThreeMonths : '3-months',
      TwelveMonths: '12-months',
      Yield       : 'Yield'
    },
    GapAnalysis: {
      Title        : 'Gap Analysis',
      TitleInfo    : 'Gap Analysis Overview',
      Total        : 'Total',
      GrossExposure: 'Gross Exposure',
      NetExposure  : 'Net Exposure',
      FixedRate    : 'Fixed Rate',
      FloatingRate : 'Floating Rate',
      Loans        : 'Loans',
      Deposits     : 'Deposits',
      Investments  : 'Investments'
    },
    LoansPortfolio: {
      DescriptiveStatistics: {
        Title: 'Descriptive Statistics',
        Size : {
          Title      : 'Size',
          Description: 'Total Value of Loans'
        },
        Loans: {
          Title      : 'Loans',
          Description: 'Number of Contracts'
        },
        Maturity: {
          Title      : 'Maturity',
          Description: 'Average Loans Maturiy Period'
        },
        Repricing: {
          Title      : 'Repricing',
          Description: 'Average Repricing Period'
        },
        LoansValue: {
          Title      : 'Loans Value',
          Description: 'Average Notional per Loan'
        },
        Duration: {
          Title      : 'Duration',
          Description: 'Effective Portfolio Duration'
        }
      },
      LoansMaturity: {
        Title  : 'Loans Maturity',
        InfoTip: 'MISSING TOOLTIP',
        Legend : {
          Actual   : 'Actual Maturity',
          Repricing: 'Repricing Period'
        }
      },
      DynamicEvolution: {
        Title         : 'Dynamic Evolution',
        UpdateInterval: 'Last 12m Change',
        InfoTip       : 'MISSING TOOLTIP',
        Size          : {
          Title   : 'Size',
          SubTitle: 'Total Value of Loans'
        },
        Loans: {
          Title   : 'Loans',
          SubTitle: 'Number of Contracts'
        },
        Duration: {
          Title     : 'Duration',
          SubTitle  : 'Effective Portfolio Duration',
          MetricUnit: 'years'
        },
        Interest: {
          Title              : 'Interest Income',
          SubTitle           : 'Annualized',
          SwitchEnabledLabel : 'Dollar Value',
          SwitchDisabledLabel: 'Average Yield %'
        }

      },
      FixedFloatingComparison: {
        Title  : 'Fixed vs Floating Rates',
        InfoTip: 'MISSING TOOLTIP',
        Legend : {
          Fixed   : 'Fixed Rate',
          Floating: 'Floating Rate',
          Coupon  : 'Coupon'
        }
      },
      LoansConcentration: {
        Title : 'Loan Concentration per Type of Loan',
        Labels: {
          ConcentrationsTitle   : 'Concentrations',
          PercentageOfContracts : '% of Contracts',
          TotalValueOfLoans     : 'Total Value of Loans',
          SwitchTotalLabel      : 'Total Value of Loans',
          SwitchPercentageLabel : 'Percentage of Contracts',
          TooltipPercentageLabel: 'Percentage',
          TooltipValueLabel     : 'Value'
        }
      },
      LoanTypeAllocation: {
        Title       : 'Loan Type Allocation',
        TableHeaders: {
          LoanType         : 'Loan Type',
          NumberOfContracts: 'Number of Contracts',
          TotalLoanValue   : 'Total Loan Value'
        },
        ToggleSwitch: {
          DisabledLabel: 'Amount of Contracts',
          EnabledLabel : 'Total Loan Value'
        }
      },
      NetInterestIncome: {
        Title  : 'Net Interest Income',
        Periods: {
          ThreeMonths: '3-months',
          OneYear    : '1-year'
        }
      }
    },
    DepositsPortfolio: {
      DescriptiveStatistics: {
        Title: 'Descriptive Statistics',
        Size : {
          Title      : 'Size',
          Description: 'Total Value of Deposits'
        },
        Deposits: {
          Title      : 'Deposits',
          Description: 'Number of Accounts'
        },
        Maturity: {
          Title      : 'Maturity',
          Description: 'Average Maturity of Time Deposits Only'
        },
        Repricing: {
          Title      : 'Yield',
          Description: 'Average Yield Percentage'
        },
        DepositsValue: {
          Title      : 'Deposits Value',
          Description: 'Average Notional per Deposit'
        },
        Duration: {
          Title      : 'Duration',
          Description: 'Effective Duration of Time Deposits Only'
        }
      },
      TimeDeposits: {
        Title  : 'Time Deposits',
        InfoTip: 'MISSING TOOLTIP',
        Legend : {
          Actual: 'Actual Maturity'
        }
      },
      DynamicEvolution: {
        Title         : 'Dynamic Evolution',
        UpdateInterval: 'Last 12m Change',
        InfoTip       : 'MISSING TOOLTIP',
        Size          : {
          Title   : 'Size',
          SubTitle: 'Total Value of Deposits'
        },
        Deposits: {
          Title   : 'Deposits',
          SubTitle: 'Number of Accounts'
        },
        Yield: {
          Title   : 'Yield',
          SubTitle: 'Average Yield Percentage'
        },
        Interest: {
          Title              : 'Interest Expense',
          SubTitle           : 'Annualized',
          SwitchEnabledLabel : 'Dollar Value',
          SwitchDisabledLabel: 'Average Yield %'
        }
      },
      FixedVsFloatingRates: {
        Title       : 'Fixed vs Floating Rates',
        InfoTip     : 'MISSING TOOLTIP',
        FixedRate   : 'Fixed Rate',
        FloatingRate: 'Floating Rate',
        Coupon      : 'Coupon'

      },
      DepositsConcentration: {
        Title : 'Deposit Concentration',
        Labels: {
          ConcentrationsTitle   : 'Concentrations',
          PercentageOfContracts : '% of Accounts',
          TotalValueOfDeposits  : 'Total Value of Deposits',
          SwitchTotalLabel      : 'Total Value of Deposits',
          SwitchPercentageLabel : 'Percentage of Accounts',
          TooltipPercentageLabel: 'Percentage',
          TooltipValueLabel     : 'Value'

        }
      },
      DepositTypeAllocation: {
        Title            : 'Deposit Type Allocation',
        DepositType      : 'Deposit Type',
        NumberOfAccounts : 'Number of Accounts',
        TotalDepositValue: 'Total Value of Deposits',
        ToggleSwitch     : {
          DisabledLabel: 'Number of Accounts',
          EnabledLabel : 'Total Value of Deposits'
        }
      },
      DepositYields: {
        Title : 'Deposit Yields',
        Fields: {
          Yield            : 'Yield %',
          InterestExpensePA: 'Interest Expense p.a. '
        }
      }
    },
    InvestmentsPortfolio: {
      Yield: {
        InfoTip: 'MISSING TOOLTIP'
      },
      DescriptiveStatistics: {
        Title      : 'Descriptive Statistics',
        Investments: {
          Title      : 'Investments',
          Description: 'Amount of Contracts'
        },
        Size: {
          Title      : 'Size',
          Description: 'Total Value of Loans'
        },
        Maturity: {
          Title      : 'Maturity',
          Description: 'Average Loans Maturiy Period'
        },
        Yield: {
          Title      : 'Yield',
          Description: 'Average Yield Percentage'
        },
        MarketValue: {
          Title      : 'Market Value',
          Description: 'MtM of Portfolio'
        },
        Duration: {
          Title      : 'Duration',
          Description: 'Effective Portfolio Duration'
        }
      },
      InvestmentsMaturity: {
        Title  : 'Investments Maturity',
        InfoTip: 'MISSING TOOLTIP',
        Legend : {
          FixedCoupon   : 'Fixed Coupon',
          FloatingCoupon: 'Floating Coupon'
        }
      },
      InvestmentsYields: {
        Title : 'Investments Yields',
        Fields: {
          YieldPercentage: 'Yield %',
          IncomePA       : 'Income p.a.'
        }
      },
      InvestmentsAllocation: {
        Title       : 'Investments Allocation',
        ToggleSwitch: {
          DisabledLabel: 'Number of Investments',
          EnabledLabel : 'Notional'
        },
        TableHeaders: {
          InvestmentType: 'Type of Investment',
          Contribution  : 'Number of Investments',
          Notional      : 'Notional'
        }
      },
      DynamicEvolution: {
        Title         : 'Dynamic Evolution',
        UpdateInterval: 'Last 12m Change',
        InfoTip       : 'MISSING TOOLTIP',
        Size          : {
          Title   : 'Size',
          SubTitle: 'Total Value of Investments'
        },
        Investments: {
          Title   : 'Investments',
          SubTitle: 'Number of Contracts'
        },
        Duration: {
          Title     : 'Duration',
          SubTitle  : 'Effective Portfolio Duration',
          MetricUnit: 'years'
        },
        MarketValue: {
          Title         : 'Market Value',
          SubTitle      : 'MtM of Portfolio',
          UpdateInterval: 'Last 12m Change',
          ToggleSwitch  : {
            EnabledLabel : 'Dollar Value',
            DisabledLabel: 'Average Yield %'
          }
        },
        Yield: {
          Title         : 'Yield',
          SubTitle      : 'Average Yield Percentage',
          UpdateInterval: 'Last 12m Change'
        }
      },
      CreditQuality: {
        Title       : 'Credit Quality',
        TableHeaders: {
          Rating      : 'Rating',
          Contribution: 'Contribution',
          Total       : 'Total'
        }
      }
    }
  }
}
